import { render, staticRenderFns } from "./TarjetaCreditoBeneficios.vue?vue&type=template&id=0a72280e"
import script from "./TarjetaCreditoBeneficios.vue?vue&type=script&lang=js"
export * from "./TarjetaCreditoBeneficios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports